<div class="template" *ngIf="!mobile">


    <div>
        <br />
        <h1>New to FXCM - What you need to know:</h1>
        <br />
        <div class="box">
            <div class="col">
                <div class="row">
                    <div class="col">
                        <button (click)="open(contentAcadFXCM1)"><img class="card-img-top" src="assets/img/academyfxcm1.png"
                                alt="Card image cap"></button>
                    </div>
                    <div class="col">
                        <div class="card-body">
                            <h2 class="card-title">Infinite trading opportunities at your fingertips with FXCM</h2>
                            <p class="card-text"><small class="text-muted">by FXCM<br />1 minute</small></p>
                            <p class="card-text pText">FXCM is an online forex and CFD broker offering global market access, various trading platforms, educational resources, competitive pricing, demo accounts, and dedicated customer support.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col">
                        <button (click)="open(contentAcadFXCM2)"><img class="card-img-top" src="assets/img/academyfxcm2.png"
                                alt="Card image cap"></button>
                    </div>
                    <div class="col">
                        <div class="card-body">
                            <h2 class="card-title">Fast Forex, Shares and CFD Trading Execution Speed with FXCM</h2>
                            <p class="card-text"><small class="text-muted">by FXCM<br />1 minute</small></p>
                            <p class="card-text pText">FXCM provides fast forex, shares, and CFD trading execution speeds, ensuring traders can capitalise on market opportunities with minimal latency and reliable performance.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="box">
            <div class="col">
                <div class="row">
                    <div class="col">
                        <button (click)="open(contentAcadFXCM3)"><img class="card-img-top" src="assets/img/academyfxcm3.png"
                                alt="Card image cap"></button>
                    </div>
                    <div class="col">
                        <div class="card-body">
                            <h2 class="card-title">Low Commissions- Try Zero Commissions Share Trading with FXCM</h2>
                            <p class="card-text"><small class="text-muted">by FXCM<br />1 minute</small></p>
                            <p class="card-text pText">Try FXCM's Zero Commissions Share Trading for low-cost stock trading, maximising profits while minimizing transaction costs in a competitive environment.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col">
                        <button (click)="open(contentAcadFXCM4)"><img class="card-img-top" src="assets/img/academyfxcm4.png"
                                alt="Card image cap"></button>
                    </div>
                    <div class="col">
                        <div class="card-body">
                            <h2 class="card-title">Get Dedicated and Excellent Forex and CFD support by our FXCM Heroes</h2>
                            <p class="card-text"><small class="text-muted">by FXCM<br />1 minute</small></p>
                            <p class="card-text pText">FXCM Heroes offer dedicated, exceptional Forex and CFD support, ensuring expert assistance and guidance for your trading journey.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="box">
            <div class="col">
                <div class="row">
                    <div class="col">
                        <button (click)="open(contentAcadFXCM5)"><img class="card-img-top" src="assets/img/academyfxcm5.png"
                                alt="Card image cap"></button>
                    </div>
                    <div class="col">
                        <div class="card-body width">
                            <h2 class="card-title">Discover the Trader's Life. Start trading with FXCM on Shares, Forex, Crypto, Gold CFDs and more</h2>
                            <p class="card-text"><small class="text-muted">by FXCM<br />2 minutes</small></p>
                            <p class="card-text pText">Explore the trader's life by trading shares, forex, crypto, gold CFDs, and more with FXCM, unlocking a vast range of investment opportunities.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col" style="margin-top: 6rem">
                <a href="https://drive.google.com/drive/folders/15TWcNpYH87G_B8ULYLKGJ9ZPt3Oeq0el" target="_blank">
                    <div class="container">
                        <div class="row align-items-start justify-content-center no-gutters">
                            <div class="col-md-auto">
                                <span class="hero__play js-play" target="_blank">
                                    <img src="assets/img/svg/ico-play.svg" alt="">
                                </span>
                            </div>
                            <div class="col-md-auto" style="font-size: large">
                                Video Academy - View More
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        </div>

        <!-- <div class="boxIBKR">
            <div class="col">
                <div class="row">
                    <div class="col" style="margin-left: 13%">
                        <button (click)="open(contentAcadFXCM1)"><img class="card-img-top" src="assets/img/academyfxcm1.png"
                                alt="Card image cap"></button>
                    </div>
                </div>
                <div class="row">
                         <div class="col">
                        <div class="card-body">
                            <h2 class="card-title">Infinite trading opportunities at your fingertips with FXCM</h2>
                            <p class="card-text"><small class="text-muted">by IBKR<br />1 minute</small></p>
                        </div>
                    </div> 
                </div>
              
               
            </div>
            <div class="col">
                <div class="row">
                    <div class="col" style="margin-left: 19%">
                        <button (click)="open(contentAcadFXCM2)"><img class="card-img-top" src="assets/img/academyfxcm2.png"
                                alt="Card image cap"></button>
                    </div>
                </div>
                <div class="row">
                          <div class="col">
                        <div class="card-body">
                            <h2 class="card-title">Fast Forex, Shares and CFD Trading Execution Speed with FXCM</h2>
                            <p class="card-text"><small class="text-muted">by IBKR<br />2 minutes</small></p>
                            
                        </div>
                    </div>
                </div>
              
                </div>
        
        </div>
        
        <div class="boxIBKR">
            <div class="col">
                <div class="row">
                    <div class="col" style="margin-left: 19%">
                        <button (click)="open(contentAcadFXCM3)"><img class="card-img-top" src="assets/img/academyfxcm3.png"
                                alt="Card image cap"></button>
                    </div>
                </div>
                <div class="row">
                            <div class="col">
                        <div class="card-body">
                            <h2 class="card-title">Low Commissions- Try Zero Commissions Share Trading with FXCM</h2>
                            <p class="card-text"><small class="text-muted">by IBKR<br />5 minutes</small></p>
             
                        </div>
                    </div>
                </div>
            
                
            </div>
            <div class="col">

                <div class="row">
                    <div class="col" style="margin-left: 25%">
                        <button (click)="open(contentAcadFXCM4)"><img class="card-img-top" src="assets/img/academyfxcm4.png"
                                alt="Card image cap"></button>
                    </div>
                </div>
                <div class="row">
                       <div class="col">
                        <div class="card-body">
                            <h2 class="card-title">Get Dedicated and Excellent Forex and CFD support by our FXCM Heroes</h2>
                            <p class="card-text"><small class="text-muted">by IBKR<br />6 minutes</small></p>

                        </div>
                    </div>
                </div>
                 
               
            </div>
        </div>
        <div class="boxIBKR">
            <div class="col" style="margin-left:-6%">
                <div class="row">
                    <div class="col" style="margin-left: 20%">
                        <button (click)="open(contentAcadFXCM5)"><img class="card-img-top" src="assets/img/academyfxcm5.png"
                                alt="Card image cap"></button>
                    </div>
                </div>
                <div class="row">
                                      <div class="col">
                        <div class="card-body width">
                            <h2 class="card-title">Discover the Trader's Life. Start trading with FXCM on Shares, Forex, Crypto, Gold CFDs and more</h2>
                            <p class="card-text"><small class="text-muted">by eToro<br />2 minutes</small></p>

                        </div>
                    </div>
                </div>
  
             
            </div>
            <div class="col" style="margin-top: 6rem">
                <a href="https://drive.google.com/drive/folders/15TWcNpYH87G_B8ULYLKGJ9ZPt3Oeq0el" target="_blank">
                    <div class="container">
                        <div class="row align-items-start justify-content-center no-gutters">
                            <div class="col-md-auto">
                                <span class="hero__play js-play" target="_blank">
                                    <img src="assets/img/svg/ico-play.svg" alt="">
                                </span>
                            </div>
                            <div class="col-md-auto" style="font-size: large">
                                Video Academy - View More
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        </div> -->

        
    </div>

    
</div>

<div class="template" *ngIf="mobile">
    <br />
    <h1>New to FXCM - What you need to know:</h1>
    <div class='carousel-wrapper'>
        <ul class='carousel x mandatory'>
            <li class="bg-white">
                <div class="row cardItem">
                    <div class="col">
                        <div class="card">
                            <button (click)="open(contentAcadFXCM1)"><img class="card-img-top" src="assets/img/academyfxcm1.png"
                                    alt="Card image cap"></button>
                            <div class="card-body">
                                <h2 class="card-title">Infinite trading opportunities at your fingertips with FXCM</h2>
                                <p class="card-text"><small class="text-muted">by eToro<br />1 minute</small></p>
                                <p class="card-text pTextOther">Are you beginning your investment journey on eToro? That’s
                                    great!
                                    Here are 4
                                    key
                                    points to get to know while you make your first steps.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
            <li class="bg-white">
                <div class="row cardItem">
                    <div class="col">
                        <div class="card">
                            <button (click)="open(contentAcadFXCM2)"><img class="card-img-top" src="assets/img/academyfxcm2.png"
                                    alt="Card image cap"></button>
                            <div class="card-body">
                                <h2 class="card-title">Fast Forex, Shares and CFD Trading Execution Speed with FXCM</h2>
                                <p class="card-text"><small class="text-muted">by eToro<br />2 minutes</small></p>
                                <p class="card-text pTextOther">Trust is at the heart of every community. That goes without
                                    saying
                                    for
                                    eToro’s.
                                    Here are the steps to follow when joining our 30M investor community.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
            <li class="bg-white">
                <div class="row cardItem">
                    <div class="col">
                        <div class="card">
                            <button (click)="open(contentAcadFXCM3)"><img class="card-img-top" src="assets/img/academyfxcm3.png"
                                    alt="Card image cap"></button>
                            <div class="card-body">
                                <h2 class="card-title">Low Commissions- Try Zero Commissions Share Trading with FXCM</h2>
                                <p class="card-text"><small class="text-muted">by eToro<br />5 minutes</small></p>
                                <p class="card-text pTextOther">Whether you’re a beginner or an experienced investor,
                                    CopyTrader
                                    allows you
                                    to copy
                                    the actions of Top Traders automatically. See how with this tutorial.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
            <li class="bg-white">
                <div class="row cardItem">
                    <div class="col">
                        <div class="card">
                            <button (click)="open(contentAcadFXCM4)"><img class="card-img-top" src="assets/img/academyfxcm4.png"
                                    alt="Card image cap"></button>
                            <div class="card-body">
                                <h2 class="card-title">Get Dedicated and Excellent Forex and CFD support by our FXCM Heroes</h2>
                                <p class="card-text"><small class="text-muted">by eToro<br />6 minutes</small></p>
                                <p class="card-text pTextOther">Learn how to verify your eToro account and find out what are
                                    the
                                    necessary
                                    steps
                                    you're required to take in order to do so with the help of this tutorial.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
            <li class="bg-white">
                <div class="row cardItem">
                    <div class="col">
                        <div class="card">
                            <button (click)="open(contentAcadFXCM5)"><img class="card-img-top" src="assets/img/academyfxcm5.png"
                                    alt="Card image cap"></button>
                            <div class="card-body">
                                <h2 class="card-title">Discover the Trader's Life. Start trading with FXCM on Shares, Forex, Crypto, Gold CFDs and more</h2>
                                <p class="card-text"><small class="text-muted">by eToro<br />2 minutes</small></p>
                                <p class="card-text pTextOther">Discover eToro's Stop Loss and Take Profit features and
                                    understand
                                    how they
                                    can
                                    help you manage your trades better with the help of this quick tutorial.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </li>

        </ul>
        <div class='position x mandatory'></div>
    </div>
 
    <div class="row mt-2">
        <div class="col">
            <a href="https://drive.google.com/drive/folders/15TWcNpYH87G_B8ULYLKGJ9ZPt3Oeq0el" target="_blank">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <span>
                                <img src="assets/img/playbtn.png">
                            </span>
                        </div>
                        <div class="col" style="font-size: medium">
                            Video Academy - View More

                        </div>
                    </div>
                </div>
            </a>
        </div>
    </div>
    <!-- <div style="text-align: center"><iframe src="https://widget.tagembed.com/65895?view" style=" width:760px;height:1260px;overflow: auto;" frameborder="0" allowtransparency="true"></iframe></div> -->

</div>


<ng-template #contentAcadFXCM1 let-modal>
    <div class="modal-header">
        <h1 class="modal-title" id="modal-basic-title">Infinite trading opportunities at your fingertips with<br/> FXCM</h1>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body modalSize" style="font-size:large;">
        <iframe src="https://drive.google.com/file/d/15mYrV5xD32x6MBWOh_oWhk3PzP8EGSPI/preview" width="640" height="480"
            allow="autoplay"></iframe>
    </div>
</ng-template>

<ng-template #contentAcadFXCM2 let-modal>
    <div class="modal-header">
        <h1 class="modal-title" id="modal-basic-title">Fast Forex, Shares and CFD Trading Execution Speed<br/> with FXCM</h1>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body modalSize" style="font-size:large;">
        <iframe src="https://drive.google.com/file/d/15c4oYC-nYrm-66q9h3oehphVqhBa1bST/preview" width="640" height="480"
            allow="autoplay"></iframe>
    </div>
</ng-template>

<ng-template #contentAcadFXCM3 let-modal>
    <div class="modal-header">
        <h1 class="modal-title" id="modal-basic-title">Low Commissions- Try Zero Commissions Share<br/> Trading with FXCM</h1>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body modalSize" style="font-size:large;">
        <iframe src="https://drive.google.com/file/d/15ih67dyrdy0d5w7FfYzrOoFcxZ7ja3k2/preview" width="640" height="480"
            allow="autoplay"></iframe>
    </div>
</ng-template>

<ng-template #contentAcadFXCM4 let-modal>
    <div class="modal-header">
        <h1 class="modal-title" id="modal-basic-title">Get Dedicated and Excellent Forex and CFD support by<br/> our FXCM Heroes</h1>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body modalSize" style="font-size:large;">
        <iframe src="https://drive.google.com/file/d/15ebO5liSUdEGlZeD4SW6fGdy5ssHt3zy/preview" width="640" height="480"
            allow="autoplay"></iframe>
    </div>
</ng-template>

<ng-template #contentAcadFXCM5 let-modal>
    <div class="modal-header">
        <h1 class="modal-title" id="modal-basic-title">
            Discover the Trader's Life. Start trading with FXCM<br/> on Shares, Forex, Crypto, Gold CFDs and more</h1>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body modalSize" style="font-size:large;">
        <iframe src="https://drive.google.com/file/d/15aHsjNc6SSMRFX17LOxBaseCXAf_VlCk/preview" width="640" height="480"
            allow="autoplay"></iframe>
    </div>
</ng-template>